import React, { useState, Fragment } from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';
import Checkbox from "@mui/material/Checkbox";
import Swal from "sweetalert2";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SurgicalHistoryDialog from "./Dialogues/SurgicalHistoryDialog";
import MedicationHistoryDialog from "./Dialogues/MedicationHistoryDialog";
import ClinicalTestDialog from "./Dialogues/ClinicalTestDialog";
import moment from 'moment';
import greyTick from "../Assets/images/patientDetail/greyTick.svg";
import greyLine from "../Assets/images/patientDetail/greyLine.svg";
import yellowTick from "../Assets/images/patientDetail/yellowTick.svg";
import yellowLine from "../Assets/images/patientDetail/yellowLine.svg";
import greenTick from "../Assets/images/patientDetail/greenTick.svg";
import greenLine from "../Assets/images/patientDetail/greenLine.svg";



const MedicalRecords = () => {
  const [personalHistory, setPersonalHistory] = useState({
    substanceAbuse: '',
    alcohol: false,
    tobacco: false,
    drugs: false,
    alcoholAbuse: '',
    alcoholUsageDuration: '',
    tobaccoAbuse: '',
    tobaccoUsageDuration: '',
    narcoticsAbuse: '',
    narcoticsUsageDuration: '',
    personnelHistory: '',
    personnelHistoryComments: '',
    active_tb_past: '',
    known_person_having_active_tb: '',
  });
  const [historyOfSubstanceAbuseError, setHistoryOfSubstanceAbuseError] = useState(false);
  const [alcoholUsageDurationError, setAlcoholUsageDurationError] = useState(false);
  const [tobaccoUsageDurationError, setTobaccoUsageDurationError] = useState(false);
  const [narcoticsUsageDurationError, setNarcoticsUsageDurationError] = useState(false);
  const [personnelHistoryCommentsError, setPersonnelHistoryCommentsError] = useState(false);
  const [positionVal, setPositionVal] = useState(1);
  const [showSurgicalModal, setShowSurgicalModal] = useState(false);
  const [surgicalHistoryData, setSurgicalHistoryData] = useState([]);

  const medicalConditions = [
    { id: 1, name: 'Personal History' },
    { id: 2, name: 'Medical/Surgical History' },
    { id: 3, name: 'Medical Condition'},
    { id: 4, name: 'Medication History'},
    { id: 5, name: 'Clinical Test'},
    { id: 6, name: 'Adversement Monitoring'},
    { id: 7, name: 'Study Completetion Details'},
  ];

  const handleInputChange = (field, value) => {
    setPersonalHistory(prevState => ({
      ...prevState,
      [field]: value,
    }));
  };

  const validateSubstanceAbuse = () => {
    if (!personalHistory.alcohol && !personalHistory.tobacco && !personalHistory.drugs) {
      setHistoryOfSubstanceAbuseError(true);
      return false;
    }
    setHistoryOfSubstanceAbuseError(false);
    return true;
  };

  const validateForm = () => {
    let valid = true;
    if (personalHistory.alcoholAbuse !== 'No' && personalHistory.alcoholUsageDuration === '') {
      setAlcoholUsageDurationError(true);
      valid = false;
    } else {
      setAlcoholUsageDurationError(false);
    }
    if (personalHistory.tobaccoAbuse === 'Yes' && personalHistory.tobaccoUsageDuration === '') {
      setTobaccoUsageDurationError(true);
      valid = false;
    } else {
      setTobaccoUsageDurationError(false);
    }
    if (personalHistory.narcoticsAbuse === 'Yes' && personalHistory.narcoticsUsageDuration === '') {
      setNarcoticsUsageDurationError(true);
      valid = false;
    } else {
      setNarcoticsUsageDurationError(false);
    }
    if (personalHistory.personnelHistory === 'Yes' && personalHistory.personnelHistoryComments === '') {
      setPersonnelHistoryCommentsError(true);
      valid = false;
    } else {
      setPersonnelHistoryCommentsError(false);
    }
    return valid;
  };

  const handleNextClick = () => {
    if (validateSubstanceAbuse() && validateForm()) {
      setPositionVal(positionVal + 1);
    }
  };
  const onCloseSurgicalModal = (data) => {
    if (data !== "cancel") {
      data["startDate"] = data.startDate ? moment(data.startDate).format("YYYY:MM:DD") : "";
      data["endDate"] = data.endDate ? moment(data.endDate).format("YYYY:MM:DD") : "";
      setSurgicalHistoryData([...surgicalHistoryData, data]);
    }
    setShowSurgicalModal(false);
  };

  return (
    <div>
      <div className="progressBar">
        {medicalConditions.map((condition) => (
          <div
            key={condition.id}
            onClick={() => setPositionVal(condition.id)}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex">
              <div className="d-grid justify-items-center">
                <img
                  alt=""
                  src={
                    positionVal === condition.id
                      ? yellowTick
                      : positionVal > condition.id
                      ? greenTick
                      : greyTick
                  }
                />
                <div
                  className={`title ${
                    positionVal === condition.id
                      ? "yellowTitle"
                      : positionVal > condition.id
                      ? "greenTitle"
                      : "greyTitle"
                  }`}
                >
                  {condition.name}
                </div>
              </div>
              {medicalConditions.length !== condition.id && (
                <img
                  className="lineDecoration"
                  alt=""
                  src={
                    positionVal === condition.id
                      ? yellowLine
                      : positionVal > condition.id
                      ? greenLine
                      : greyLine
                  }
                />
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="medicalRecordHeader">Medical Records</div>
        <div className="medicalrecord">
          {/* Question 1 */}
          <div className="questions">
            <span className="number">1. </span>Does the subject have any History of Substance abuse?
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="substanceAbuse"
                value={personalHistory.substanceAbuse}
                onChange={(e) => handleInputChange('substanceAbuse', e.target.value)}
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </div>
            {personalHistory.substanceAbuse === "Yes" && (
              <div className="subquestions">
                Please specify the Substance:
                <div className="checkboxes">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={personalHistory.alcohol}
                        onChange={(e) => handleInputChange('alcohol', e.target.checked)}
                      />
                    }
                    label="Alcohol"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={personalHistory.tobacco}
                        onChange={(e) => handleInputChange('tobacco', e.target.checked)}
                      />
                    }
                    label="Tobacco"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={personalHistory.drugs}
                        onChange={(e) => handleInputChange('drugs', e.target.checked)}
                      />
                    }
                    label="Drugs (Narcotic)"
                  />
                </div>
                {historyOfSubstanceAbuseError && (
                  <div className="errorMessage">
                    Please Select Atleast One Substance Abuse
                  </div>
                )}
              </div>
            )}
          </div>
          {/* Question 2 */}
          <div className="questions">
            <span className="number">2. </span>Did the Subject continuing the use of Alcohol?
            <div className="options">
              <RadioGroup
                row
                aria-label="gender"
                name="alcohol"
                value={personalHistory.alcoholAbuse}
                onChange={(e) => handleInputChange('alcoholAbuse', e.target.value)}
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </div>
            {personalHistory.alcoholAbuse !== "No" && (
              <Fragment>
                <div className="subquestions">
                  Duration of Alcohol use:
                </div>

                <div>
                  <input
                    className="border"
                    type="text"
                    value={personalHistory.alcoholUsageDuration}
                    onChange={(e) => handleInputChange('alcoholUsageDuration', e.target.value)}
                  />
                </div>
                {alcoholUsageDurationError && (
                  <div className="errorMessage">
                    Duration Required*
                  </div>
                )}
              </Fragment>
            )}
          </div>
          {/* Question 3 */}
          <div className="questions">
              <span className="number">3. </span>Did the Subject continuing the use of Tobacco?
              <div className="options">
              <RadioGroup
                  row
                  aria-label="gender"
                  name="tobacco"
                  value={personalHistory.tobaccoAbuse}
                  onChange={(e) => handleInputChange('tobaccoAbuse', e.target.value)}
              >
                  <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                  />
                  <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                  />
              </RadioGroup>
              </div>
              {personalHistory.tobaccoAbuse === "Yes" && (
              <Fragment>
                  <div className="subquestions">
                  Duration of Tobacco use:
                  </div>
                  <div>
                  <input
                      className="border"
                      type="text"
                      value={personalHistory.tobaccoUsageDuration}
                      onChange={(e) => handleInputChange('tobaccoUsageDuration', e.target.value)}
                  />
                  </div>
                  {tobaccoUsageDurationError && (
                  <div className="errorMessage">
                      Duration Required*
                  </div>
                  )}
              </Fragment>
              )}
          </div>
          {/* Question 4 */}
          <div className="questions">
              <span className="number">4. </span>Did the Subject continuing the use of Drugs (Narcotic)?
              <div className="options">
              <RadioGroup
                  row
                  aria-label="gender"
                  name="drugs"
                  value={personalHistory.narcoticsAbuse}
                  onChange={(e) => handleInputChange('narcoticsAbuse', e.target.value)}
              >
                  <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                  />
                  <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                  />
              </RadioGroup>
              </div>
              {personalHistory.narcoticsAbuse === "Yes" && (
              <Fragment>
                  <div className="subquestions">
                  Duration of Drugs (Narcotic) use:
                  </div>
                  <div>
                  <input
                      className="border"
                      type="text"
                      value={personalHistory.narcoticsUsageDuration}
                      onChange={(e) => handleInputChange('narcoticsUsageDuration', e.target.value)}
                  />
                  </div>
                  {narcoticsUsageDurationError && (
                  <div className="errorMessage">
                      Duration Required*
                  </div>
                  )}
              </Fragment>
              )}
          </div>
          {/* Question 5 */}
          <div className="questions">
              <span className="number">5. </span>Did the subject have any other personal history?
              <div className="options">
              <RadioGroup
                  row
                  aria-label="gender"
                  name="personalHistory"
                  value={personalHistory.personnelHistory}
                  onChange={(e) => handleInputChange('personnelHistory', e.target.value)}
              >
                  <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                  />
                  <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                  />
              </RadioGroup>
              </div>
              {personalHistory.personnelHistory === "Yes" && (
              <Fragment>
                  <div className="subquestions">
                  Please Specify Your Comment:
                  </div>
                  <div>
                  <input
                      className="border"
                      type="text"
                      value={personalHistory.personnelHistoryComments}
                      onChange={(e) => handleInputChange('personnelHistoryComments', e.target.value)}
                  />
                  </div>
                  {personnelHistoryCommentsError && (
                  <div className="errorMessage">
                      Comment Required*
                  </div>
                  )}
              </Fragment>
              )}
          </div>
          {/* Question 6 */}
          <div className="questions">
              <span className="number">6. </span>Did the subject have active TB in the past?
              <div className="options">
              <RadioGroup
                  row
                  aria-label="active_tb_past"
                  name="active_tb_past"
                  value={personalHistory.active_tb_past}
                  onChange={(e) => handleInputChange('active_tb_past', e.target.value)}
              >
                  <FormControlLabel
                  value="Yes"
                  control={<Radio />}
                  label="Yes"
                  />
                  <FormControlLabel
                  value="No"
                  control={<Radio />}
                  label="No"
                  />
              </RadioGroup>
              </div>
          </div>
        </div>
        <div className="buttonStyles">
          <button className="btn primary-button" onClick={handleNextClick}>Next</button>
        </div>

        <div className="medicalRecordHeader">
        {medicalConditions[positionVal - 1]?.name}
      </div>
      <div className="medicalrecord">
        <div className="questions">Please fill out the following table, if applicable:</div>
      </div>
      <div className="surgicalHistory">
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Event/Diagnosis</TableCell>
                <TableCell>Start Date(DD/MM/YYYY)</TableCell>
                <TableCell>End Date(DD/MM/YYYY)</TableCell>
                <TableCell>On Going(Yes/No)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {surgicalHistoryData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.Diagnosis}</TableCell>
                  <TableCell>{row.startDate}</TableCell>
                  <TableCell>{row.endDate}</TableCell>
                  <TableCell>{row.ongoing ? 'True' : 'False'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="buttonStyles">
        <button className="btn secondary-button" onClick={() => setShowSurgicalModal(true)}>
          Add Row
        </button>
      </div>
      {showSurgicalModal && (
        <ClinicalTestDialog
          open={showSurgicalModal}
          handleClose={(data) => onCloseSurgicalModal(data)}
        />
      )}
      <div className="buttonStyles">
        <button className="btn secondary-button" onClick={() => setPositionVal(1)}>
          Previous
        </button>
        <button className="btn primary-button" onClick={() => setPositionVal(3)}>
          Next
        </button>
      </div>
    </div>
  );
};

export default MedicalRecords;
